export default __webpack_public_path__ + "c60571781d59b6fe77c37655a1c4ad07.svg";